module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "width": "100px"
    },
    style: (_vm.getModuleStyle(0)),
    on: {
      "click": function($event) {
        return _vm.setTab(0)
      }
    }
  }, [_vm._v("Kompanija")]), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "width": "80px"
    },
    style: (_vm.getModuleStyle(1)),
    on: {
      "click": function($event) {
        return _vm.setTab(1)
      }
    }
  }, [_vm._v("Faktura")]), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "width": "80px"
    },
    style: (_vm.getModuleStyle(2)),
    on: {
      "click": function($event) {
        return _vm.setTab(2)
      }
    }
  }, [_vm._v("Popusti")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.showImageHolder) ? _c('div', {
    staticClass: "foo"
  }, [_c('br'), _vm._v(" "), (_vm.selectedImage == null) ? _c('div', [(_vm.companyImage != null) ? _c('img', {
    attrs: {
      "src": _vm.companyImage,
      "width": "100px",
      "height": "100px"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.selectedImage != null) ? _c('div', [(_vm.selectedImagePreview != null) ? _c('img', {
    attrs: {
      "src": _vm.selectedImagePreview,
      "height": "100px"
    }
  }) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.selectedImage == null) ? _c('label', {
    staticClass: "text-reader"
  }, [_vm._v("\n              Učitaj logo "), _c('i', {
    staticClass: "ti-upload"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.loadTextFromFile
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedImage != null) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.selectedImage != null) ? _c('div', {
    staticClass: "text-reader",
    on: {
      "click": function($event) {
        return _vm.deleteSelectedImage()
      }
    }
  }, [_vm._v("\n              Poništi sliku "), _c('i', {
    staticClass: "ti-trash"
  })]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Max 5 MB")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 form-group"
  }, [_c('label', [_vm._v("Ime Kompanije")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 form-group"
  }, [_c('label', [_vm._v("Interno ime")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalName),
      expression: "internalName"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "internalName"
    },
    domProps: {
      "value": (_vm.internalName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internalName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Latitude")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lat),
      expression: "lat"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "password"
    },
    domProps: {
      "value": (_vm.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Longitude")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lng),
      expression: "lng"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "password"
    },
    domProps: {
      "value": (_vm.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lng = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Broj telefona")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usingVouchers),
      expression: "usingVouchers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.usingVouchers) ? _vm._i(_vm.usingVouchers, null) > -1 : (_vm.usingVouchers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.usingVouchers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.usingVouchers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.usingVouchers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.usingVouchers = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', [_c('label', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Da li kompanija koristi kupon?"), _c('label', {
    staticStyle: {
      "color": "forestgreen"
    }
  })])]), _vm._v("\n                \n                     "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visibleForCustomer),
      expression: "visibleForCustomer"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    },
    domProps: {
      "checked": Array.isArray(_vm.visibleForCustomer) ? _vm._i(_vm.visibleForCustomer, null) > -1 : (_vm.visibleForCustomer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.visibleForCustomer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visibleForCustomer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.visibleForCustomer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visibleForCustomer = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', [_c('label', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "for": "checkbox1"
    }
  }, [_vm._v("Vidljivo za kupce?"), _c('label', {
    staticStyle: {
      "color": "forestgreen"
    }
  })])]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive),
      expression: "archive"
    }],
    attrs: {
      "type": "checkbox",
      "id": "cb2"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive) ? _vm._i(_vm.archive, null) > -1 : (_vm.archive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.archive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.archive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.archive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.archive = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', [_c('label', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "for": "cb2"
    }
  }, [_vm._v("Arhiva"), _c('label', {
    staticStyle: {
      "color": "forestgreen"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Naziv")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.email),
      expression: "info.email"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": (_vm.info.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Adresa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.address),
      expression: "info.address"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.info.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Zip")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.zip),
      expression: "info.zip"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.info.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "zip", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Grad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.city),
      expression: "info.city"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.info.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("PIB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.pib),
      expression: "info.pib"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.info.pib)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "pib", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("MB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.mb),
      expression: "info.mb"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.info.mb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "mb", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Popust za grad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discounts.city),
      expression: "discounts.city"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "username"
    },
    domProps: {
      "value": (_vm.discounts.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.discounts, "city", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isLoading) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": _vm.buttonTitle,
      "name": "azuriraj",
      "value": _vm.buttonTitle
    },
    on: {
      "click": function($event) {
        return _vm.uploadImage()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-522fd256!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddCompanyModal.vue
// module id = 482
// module chunks = 1